export default __webpack_public_path__ + "media/music/16f31decb4c2f664cf3e42c95bb1df7c.mp3";